import { Form } from 'react-bootstrap';

interface ClientNotesFieldProps {
  notes: string;
  onNotesChange: (notes: string) => void;
}

/** Free notes Arcanum keeps about a client. They are not deployed. */
export function ClientNotesField({ notes, onNotesChange }: ClientNotesFieldProps) {
  return (
    <Form.Group controlId="client-notes">
      <Form.Label>Notes</Form.Label>
      <Form.Control
        as="textarea"
        rows={4}
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        placeholder="Anything the team should know about this client"
      />
    </Form.Group>
  );
}

export default ClientNotesField;
